import React, { useState } from 'react';
import { VStack, Box, Text, Image, HStack, Button, Icon, chakra, Spacer, Flex, Grid, Alert, AlertIcon } from '@chakra-ui/react';
import { FaCalendarAlt } from 'react-icons/fa';
import { ArrowBackIcon, WarningIcon, WarningTwoIcon } from '@chakra-ui/icons';
import Medico from '../../../../../../images/modalPsicologo.svg';
import BackButton from '../../../../../../images/assets/telemedicina/backbutton.svg';
import aviso from '../../../../../../images/aviso.svg';
import useModelConfirmacao from './useModelConfirmacao';
import { IoMdCalendar } from 'react-icons/io';

const navigate = (path) => console.log(`Navegando para: ${path}`);

const HeaderRow = ({ label, value, valueColor = '#5AB2AE' }) => (
  <>
    <Text color="#757575" fontWeight="bold" textAlign="right" whiteSpace="nowrap">
      {label}:
    </Text>

    <Text color={valueColor} fontWeight="bold" textAlign="left" whiteSpace="nowrap">
      {value}
    </Text>
  </>
);

const InfoRow = ({ label, value, valueColor = '#616161', isHeader = false }) => (
  <Flex align="center" py={isHeader ? 1 : 0.5} borderBottom={isHeader ? '1px solid #e0f0f0' : 'none'}>
    <Text color="#757575" fontWeight="bold">
      {label}:
    </Text>
    <Text color={valueColor} fontWeight="bold" ml={2} isTruncated maxW={{ base: '150px', sm: '280px' }} title={value}>
      {value}
    </Text>
  </Flex>
);

const Confirmacao = () => {
  function capitalize(text) {
    if (!text || typeof text !== 'string') return '';
    const preps = ['da', 'das', 'de', 'do', 'dos', 'e', 'di', 'du', 'des', 'd'];
    return text
      .split(' ')
      .map((word, idx) => {
        const lower = word.toLowerCase();
        if (preps.includes(lower) && idx !== 0) return lower;
        return lower.charAt(0).toUpperCase() + lower.slice(1);
      })
      .join(' ');
  }
  const {
    loading,
    navigate,
    paciente,
    assinante,
    medico,
    clientePendente,
    fetchAgendamentoEspecialista,
    error,
    agendamento,
    user,
    bloqueadoPorIdadePsicologia,
  } = useModelConfirmacao();

  const [imageLoading, setImageLoading] = useState(true);
  const procedimentoEspeciadadeSelecionada = medico?.medico?.especialidades;
  const especialidade = procedimentoEspeciadadeSelecionada ? procedimentoEspeciadadeSelecionada : medico.horarios[0].procedimentos;
  const procedimentos = medico.horarios[0].procedimentos;

  const appointmentData = {
    date: agendamento?.data,
    time: agendamento?.horario,
    patient: paciente?.nome || '',
    professional: medico?.medico?.nome || '',
    specialty: especialidade?.[0]?.especialidade
      || (medico.medico.especialidades && medico.medico.especialidades.length > 0 ? 
        medico.medico.especialidades.map(e=>capitalize(e)).join(', ') :
        medico.medico.especialidade)
      || '',
    value:
      assinante && !clientePendente
        ? (Number(procedimentos?.[0]?.valor) * 0.5).toFixed(2)
        : assinante && !clientePendente && user.id_plano === 70
          ? Number(procedimentos?.[0]?.procedimento_convenio?.valor ?? 0)
          : (Number(procedimentos?.[0]?.procedimento_particular?.valor || procedimentos?.[0]?.procedimento_particular?.particular_valor || 0) * 0.5).toFixed(2),
  };

  const telemedicinaGratis = agendamento?.especialista ? agendamento?.telemedicina_especialista_gratis : agendamento?.telemedicina_gratuita;

  let titulo = '';
  if (medico?.medico?.sexo === 'M') {
    titulo = 'Dr. ';
  } else if (medico?.medico?.sexo === 'F') {
    titulo = 'Dra. ';
  }
  let valor = 0;
  console.log('procedimentos', procedimentos);
  return (
    <VStack bg="gray.50" minH="100vh" w="100vw" spacing={0} p={4}>
      <VStack w="100%" maxW="md" position="relative" align="center" spacing={4}>
        <Box position="relative" w={{ base: '30%', md: '20%' }}>
          {imageLoading && (
            <Flex justify="center" align="center" w="100%" h="100%" position="absolute" top={0} left={0} zIndex={1}>
              <chakra.div display="flex" justifyContent="center" alignItems="center" w="100%" h="100%">
                <Box
                  as="span"
                  className="chakra-spinner"
                  w="40px"
                  h="40px"
                  borderWidth="4px"
                  borderStyle="solid"
                  borderColor="#5AB2AE transparent #5AB2AE transparent"
                  borderRadius="50%"
                  animation="spin 1s linear infinite"
                />
              </chakra.div>
            </Flex>
          )}
          <Image
            src={Medico}
            alt="Médico(a)"
            mt={4}
            w="100%"
            borderRadius="full"
            onLoad={() => setImageLoading(false)}
            style={imageLoading ? { visibility: 'hidden' } : {}}
          />
        </Box>

        <VStack spacing={0}>
          <Text color="#5AB2AE" fontWeight="bold" fontSize="1.5em">
            Pré-agendamento realizado
          </Text>
          <Text color="#616161" fontSize="sm" textAlign="center">
            Confira abaixo as informações do seu <br /> atendimento com especialista.
          </Text>
        </VStack>

        <Box borderRadius="0.8em" p={4} shadow="md" bg="white" border="1px solid #e0f0f0" w="100%">
          <Box display="flex" flexDirection="column" gap={1} mx="auto" w="fit-content">
            <Box display="flex" alignItems="center" gap={1}>
              <Text color="#757575" fontWeight="bold" textAlign="left">
                {capitalize('Data')}:
              </Text>
              <Text color="#5AB2AE" fontWeight="bold" textAlign="left">
                {capitalize(
                  (() => {
                    if (!appointmentData.date) return '';
                    const d = new Date(appointmentData.date + 'T12:00:00');
                    if (isNaN(d.getTime())) return appointmentData.date;
                    const dia = String(d.getDate()).padStart(2, '0');
                    const mes = String(d.getMonth() + 1).padStart(2, '0');
                    const ano = d.getFullYear();
                    return `${dia}/${mes}/${ano}`;
                  })(),
                )}
              </Text>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <Text color="#757575" fontWeight="bold" textAlign="left">
                {capitalize('Horário')}:
              </Text>
              <Text color="#5AB2AE" fontWeight="bold" textAlign="left">
                {capitalize(appointmentData.time)}
              </Text>
            </Box>
          </Box>
        </Box>

        <Box borderRadius="0.8em" p={4} shadow="md" bg="white" border="1px solid #e0f0f0" w="100%">
          <InfoRow label="Paciente" value={capitalize(paciente.nome)} isHeader={true} />
          <InfoRow label="Profissional" value={titulo + capitalize(medico.medico.nome)} isHeader={true} />
          <InfoRow label="Especialista" value={capitalize(appointmentData.specialty)} isHeader={true} />

          {agendamento?.falta ? (
            <Box bg="#FFF8F0" borderRadius="md" p={3} mt={2} border="1px solid #FFD6A0">
              <InfoRow
                label="Valor da consulta"
                value={`R$ ${
                  assinante && !clientePendente
                    ? (Number(procedimentos?.[0]?.valor) * 0.5).toFixed(2)
                    : assinante && !clientePendente && user.id_plano === 70
                      ? Number(procedimentos?.[0]?.procedimento_convenio?.valor ?? 0) 
                      : (Number(procedimentos?.[0]?.procedimento_particular?.valor || procedimentos?.[0]?.procedimento_particular?.particular_valor || 0) * 0.5).toFixed(2)
                }`}
              />
              <InfoRow
                label="Acréscimo por falta (50%)"
                value={`R$ ${
                  assinante && !clientePendente
                    ? (Number(procedimentos?.[0]?.valor) * 0.5).toFixed(2)
                    : assinante && !clientePendente && user.id_plano === 70
                      ? Number(procedimentos?.[0]?.procedimento_convenio?.valor ?? 0)
                      : (Number(procedimentos?.[0]?.procedimento_particular?.valor || procedimentos?.[0]?.procedimento_particular?.particular_valor || 0) * 0.5).toFixed(2)
                }`}
                valueColor="#D62422"
              />
              <InfoRow
                label="Valor!!"
                value={(() => {
                  const faltou = false // agendamento?.faltou;

                  const valorConsulta = Number(procedimentos?.[0]?.valor ?? 0);

                   const valorParticular = Number(procedimentos?.[0]?.procedimento_particular?.valor || procedimentos?.[0]?.procedimento_particular?.[0]?.particular_valor || 0);

                  const valorCoparticipacao = Number(procedimentos?.[0]?.procedimento_convenio.valor ?? 0);

                  const especialidadeComDesconto =
                    Array.isArray(agendamento?.especialidades) &&
                    agendamento.especialidades.map(Number).includes(Number(medico?.dados?.ambulatorio_tipo_consulta_id));

                  if (faltou) {
                    if (assinante && user.id_plano === 70) {
                      valor = valorCoparticipacao * 1.5;
                    } else if (assinante) {
                      valor = valorConsulta * 1.5;
                    } else {
                      valor = valorParticular;
                    }
                  } else {
                    if (assinante && telemedicinaGratis) {
                      valor = 0;
                    } else if (assinante && especialidadeComDesconto) {
                      valor = 0;
                    } else if (assinante && user.id_plano === 70) {
                      valor = valorCoparticipacao;
                    } else if (assinante && !clientePendente) {
                      valor = valorConsulta;
                    } else {
                      valor = valorParticular;
                    }
                  }

                  return (
                    <>
                      {valor === 0
                        ? 'Gratuito'
                        : `${valor.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          })}`}
                    </>
                  );
                })()}
                valueColor={agendamento.falta && '#D62422'}
              />
              <Text color="#D62422" fontSize="sm" mt={2} fontWeight="bold" textAlign="center">
                O valor está acrescido de 50% devido à falta na consulta anterior no período de 60 dias.
              </Text>
            </Box>
          ) : (
            <InfoRow
              label="Valor"
              value={(() => {
                const faltou = false; // agendamento?.faltou;
                console.log(medico?.horarios?.[0]?.procedimentos?.[0])
                console.log(user.id_plano)
                const valorConsulta = Number(procedimentos?.[0]?.valor ?? 0);

                const valorParticular = Number(procedimentos?.[0]?.procedimento_particular?.valor || procedimentos?.[0]?.procedimento_particular?.[0]?.particular_valor || 0);
                console.log('valor particular', valorParticular);

                const valorCoparticipacao = Number(procedimentos?.[0]?.procedimento_convenio?.valor|| 0);

                let valor = 0;
                const especialidadeComDesconto =
                  Array.isArray(agendamento?.especialidades) && agendamento.especialidades.map(Number).includes(Number(agendamento?.especialidadeId));

                if (faltou) {
                  if (assinante && user.id_plano === 70) {
                    valor = valorCoparticipacao * 1.5;
                  } else if (assinante) {
                    valor = valorConsulta * 1.5;
                  } else {
                    valor = valorParticular;
                  }
                } else {
                  if (assinante && telemedicinaGratis) {
                    valor = 0;
                  } else if (assinante && especialidadeComDesconto) {
                    valor = 0;
                  } else if (assinante && user.id_plano === 70) {
                    valor = valorCoparticipacao;
                  } else if (assinante && !clientePendente) {
                    valor = valorConsulta;
                  } else {
                    valor = valorParticular;
                  }
                }

                return (
                  <>
                    {valor === 0
                      ? 'Gratuito'
                      : ` ${valor.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}`}
                  </>
                );
              })()}
              valueColor={agendamento.falta && '#D62422'}
            />
          )}
        </Box>

        <Box
          borderRadius="0.8em"
          p={4}
          w="100%"
          border="1px solid #FFCBCF"
          bg="linear-gradient(90deg, #FFEAED 0%, #FFEAED 100%)"
          boxShadow="0 0 5px rgba(255, 203, 207, 0.5)"
        >
          <VStack align="flex-start" spacing={1}>
            <HStack spacing={2}>
              <WarningTwoIcon color="#D62422" boxSize={4} />
              <Text fontWeight="bold" fontSize="0.9em" color="#D62422">
                Importante!
              </Text>
            </HStack>

            <Text textAlign={'left'} color="#D62422" fontSize="0.8em">
              Se você faltar, a consulta <b>não poderá ser reagendada</b>. Para marcar outra, <b>será necessário um novo pagamento</b>.
            </Text>
          </VStack>
        </Box>

        {bloqueadoPorIdadePsicologia && (
          <Alert status="error" borderRadius="0.8em" w="100%">
            <AlertIcon />
            Agendamento indisponível. O atendimento psicológico é exclusivo para pacientes a partir de 14 anos.
          </Alert>
        )}

        {error && (
          <Box bg="#FFF8F0" borderRadius="md" p={3} mt={2} border="1px solid #FFD6A0" w="100%">
            <HStack>
              <Icon as={WarningIcon} w={5} h={5} color="#D62422" />
              <Text color="#D62422" fontSize="sm" fontWeight="bold">
                Não foi possível concluir o agendamento. Por favor, tente novamente mais tarde.
              </Text>
            </HStack>
          </Box>
        )}

        <VStack w="100%" spacing={3} mt={6} pb={8}>
          <Button
            width="100%"
            bg="#5AB2AE"
            color="white"
            leftIcon={<Icon as={IoMdCalendar} />}
            _hover={{ bg: '#4d9c97' }}
            borderRadius="0.8em"
            size="lg"
            fontWeight="bold"
            onClick={() => fetchAgendamentoEspecialista()}
            disabled={loading || bloqueadoPorIdadePsicologia}
            loading={loading}
          >
            {valor ? 'Pagar Atendimento' : 'Agendar Atendimento!'}
          </Button>

          <Button
            width="100%"
            bg="#F5F5F5"
            color="#616161"
            leftIcon={<Icon as={ArrowBackIcon} />}
            _hover={{ bg: 'gray.100' }}
            size="md"
            onClick={() => navigate(-1)}
            borderRadius="0.8em"
            border="1px solid 616161"
          >
            Voltar
          </Button>
        </VStack>
      </VStack>
    </VStack>
  );
};

export default Confirmacao;
